import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useFlowHeaderContext } from "../../layout/header/FlowHeaderContext";
import { CONTRACT_PATH_ROUTES } from "./ContractPath";

export function TrackProgress() {
  const location = useLocation();
  const progress = useMemo(() => {
    const page = Object.values(CONTRACT_PATH_ROUTES).find(
      (x) => x.path === location.pathname
    );
    return page ? page.progress : null;
  }, [location.pathname]);
  const flowHeaderContext = useFlowHeaderContext();
  const { setProgress } = flowHeaderContext;
  useEffect(() => {
    if (progress !== null) setProgress(progress);
  }, [progress, setProgress]);
  return null;
}
